export const REWARDS = {
  minor_heal: {
    id: "minor_heal",
    type: "heal",
    category: "instant",
    name: "治療藥水",
    icon: "reward-icon-heal",
    rarity: "普通",
    description: "立即恢復 20 生命",
    amount: 20,
  },
  gold_cache: {
    id: "gold_cache",
    type: "gold",
    category: "instant",
    name: "小袋金幣",
    icon: "reward-icon-coins",
    rarity: "普通",
    description: "獲得 25 金幣",
    amount: 25,
  },
  emergency_vial: {
    id: "emergency_vial",
    type: "potion",
    category: "consumable",
    name: "緊急藥瓶",
    icon: "reward-icon-potion",
    rarity: "稀有",
    description: "之後可使用一次，恢復 35 生命",
    amount: 35,
  },
  boss_trophy: {
    id: "boss_trophy",
    type: "trophy",
    category: "milestone",
    name: "骨面核心",
    icon: "reward-icon-trophy",
    rarity: "通關遺物",
    description: "第一地層通關徽章",
    maxStacks: 1,
  },
};
